import { Checkbox } from '@distribusion/owl-frontend-ui'
import React, { useCallback } from 'react'

import amplitude from '@lib/analytics/amplitude'
import { useTranslation } from '@lib/i18n'
import { useConnectionFilters, Directions } from '@stores/connectionFilters'

import '@components/DirectOnlyFilter/index.scss'

const DirectOnlyFilter: React.FC = () => {
  const { t } = useTranslation()
  const [filterValues, setFilterValues] = useConnectionFilters()

  const isChecked = Array.isArray(filterValues.direction) && filterValues.direction.includes('directOnly')

  const handleChange = useCallback(() => {
    const value: Directions[] = !isChecked ? ['directOnly'] : []

    amplitude.results.clickFilter({ direction: value })

    setFilterValues({
      ...filterValues,
      direction: value,
    })
  }, [filterValues, setFilterValues, isChecked])

  const directOnlyLabel = t('journeyList.filters.directOnly')

  return (
    <div className="directOnlyFilter" id="directOnlyFilterContainer">
      <Checkbox
        checked={isChecked}
        onChange={handleChange}
        dataTag="directOnlyFilterCheckBox"
        ariaLabel={directOnlyLabel}
      >
        {directOnlyLabel}
      </Checkbox>
    </div>
  )
}

export default DirectOnlyFilter
